export default "__VITE_ASSET__DCQe4coD__"